
import React from 'react'
import icon from './svgs/tasksquareColored.svg'
import { BaseIcon } from './_base'

export const TasksquareColored = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
